import React, { useState } from 'react';
import { Monitor, Smartphone, Globe, Check, DollarSign, CreditCard, Eye, Edit3, X, Search, Server, Megaphone, PenTool, Shield } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const templates = [{
  id: 1,
  name: 'HipHopServers (Enterprise Pro)',
  desc: 'Premium Creator Command Center.',
  image: 'https://cdn.magicpatterns.com/uploads/gLPSaKnYdCK6YJFTjnmTs3/Screenshot_2026-04-17_at_6.46.04_AM.png',
  theme: {
    primary: 'bg-indigo-600',
    text: 'text-indigo-600',
    light: 'bg-indigo-50',
    border: 'border-indigo-100'
  },
  isSpecial: true
}, {
  id: 2,
  name: 'Creative Studio',
  desc: 'Minimalist agency portfolio.',
  image: 'https://images.unsplash.com/photo-1522542550221-31fd19575a2d?auto=format&fit=crop&q=80&w=800',
  theme: {
    primary: 'bg-slate-900',
    text: 'text-slate-900',
    light: 'bg-slate-100',
    border: 'border-slate-200'
  }
}, {
  id: 3,
  name: 'Growth Engine',
  desc: 'Lead-gen focused landing page.',
  image: 'https://images.unsplash.com/photo-1551288049-bbbda5366392?auto=format&fit=crop&q=80&w=800',
  theme: {
    primary: 'bg-emerald-600',
    text: 'text-emerald-600',
    light: 'bg-emerald-50',
    border: 'border-emerald-100'
  }
}, {
  id: 4,
  name: 'Modern Retail',
  desc: 'Digital product storefront.',
  image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=800',
  theme: {
    primary: 'bg-rose-600',
    text: 'text-rose-600',
    light: 'bg-rose-50',
    border: 'border-rose-100'
  }
}];
export function Storefront() {
  const [currency, setCurrency] = useState('USD');
  const [activeTemplate, setActiveTemplate] = useState(1);
  const [previewTemplate, setPreviewTemplate] = useState<number | null>(null);
  const getCurrencySymbol = () => {
    switch (currency) {
      case 'CAD':
        return 'C$';
      default:
        return '$';
    }
  };
  const activeTheme = previewTemplate ? templates.find(t => t.id === previewTemplate)?.theme : null;
  const sym = getCurrencySymbol();
  return <div className="space-y-8 max-w-[1600px] mx-auto" data-id="element-1318">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1319">
        <div data-id="element-1320">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1321">
            Storefront & Landing Pages
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-1322">
            Manage your conversion-optimized customer entry points.
          </p>
        </div>
        <div className="flex items-center gap-4" data-id="element-1323">
          <div className="flex bg-gray-50 p-1 rounded-lg border border-gray-200" data-id="element-1324">
            {['USD', 'CAD'].map(c => <button key={c} onClick={() => setCurrency(c)} className={`px-4 py-1.5 text-xs font-bold rounded-md transition-all ${currency === c ? 'bg-white text-indigo-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1325">
                {c}
              </button>)}
          </div>
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-1326">
            <Globe size={18} data-id="element-1327" />
            Go Live
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1328">
        {templates.map(t => <motion.div key={t.id} whileHover={{
        y: -4
      }} className={`bg-white rounded-lg border-2 overflow-hidden group transition-all ${activeTemplate === t.id ? 'border-indigo-600 shadow-md' : 'border-gray-100 shadow-sm hover:border-gray-200'}`} data-id="element-1329">
            <div className="aspect-video relative overflow-hidden bg-gray-100" data-id="element-1330">
              <img src={t.image} alt={t.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1331" />
              <div className="absolute inset-0 bg-slate-900/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2 px-4" data-id="element-1332">
                <button onClick={() => {
              if ((t as any).isSpecial) {
                window.dispatchEvent(new CustomEvent('changeTab', {
                  detail: 'hiphopservers'
                }));
              } else {
                setPreviewTemplate(t.id);
              }
            }} className="flex-1 py-2 bg-white text-slate-900 rounded-lg text-[10px] font-bold shadow-lg hover:bg-gray-50 transition-all flex items-center justify-center gap-1.5" data-id="element-1333">
                  <Eye size={12} data-id="element-1334" />{' '}
                  {(t as any).isSpecial ? 'Open Site' : 'Preview'}
                </button>
                <button onClick={() => setActiveTemplate(t.id)} className="flex-1 py-2 bg-indigo-600 text-white rounded-lg text-[10px] font-bold shadow-lg hover:bg-indigo-700 transition-all flex items-center justify-center gap-1.5" data-id="element-1335">
                  <Edit3 size={12} data-id="element-1336" /> Customize
                </button>
              </div>
              {activeTemplate === t.id && <div className="absolute top-3 right-3 bg-indigo-600 text-white px-2 py-1 rounded-full text-[10px] font-bold flex items-center gap-1 shadow-lg" data-id="element-1337">
                  <Check size={10} data-id="element-1338" /> Active
                </div>}
            </div>
            <div className="p-4" data-id="element-1339">
              <div className="flex items-center justify-between mb-1" data-id="element-1340">
                <p className="text-sm font-bold text-slate-900" data-id="element-1341">{t.name}</p>
                <div className="flex gap-1" data-id="element-1342">
                  <Monitor size={12} className="text-gray-400" data-id="element-1343" />
                  <Smartphone size={12} className="text-gray-400" data-id="element-1344" />
                </div>
              </div>
              <p className="text-xs text-gray-500 font-medium line-clamp-1" data-id="element-1345">
                {t.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <div className="bg-slate-900 rounded-lg p-8 text-white relative overflow-hidden" data-id="element-1346">
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1347">
          <div className="max-w-xl" data-id="element-1348">
            <h2 className="text-2xl font-bold mb-2" data-id="element-1349">Multi-Currency Engine</h2>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-1350">
              Your storefront automatically detects customer location and
              displays pricing in {currency}. All payouts will be converted to
              your base currency at the mid-market rate.
            </p>
          </div>
          <div className="flex gap-4" data-id="element-1351">
            <div className="bg-slate-800 p-4 rounded-lg border border-slate-700 flex items-center gap-4" data-id="element-1352">
              <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center text-green-500" data-id="element-1353">
                <DollarSign size={20} data-id="element-1354" />
              </div>
              <div data-id="element-1355">
                <p className="text-[10px] font-bold text-slate-500 uppercase" data-id="element-1356">
                  Current Rate
                </p>
                <p className="text-lg font-bold" data-id="element-1357">1 USD = 1.35 CAD</p>
              </div>
            </div>
            <div className="bg-slate-800 p-4 rounded-lg border border-slate-700 flex items-center gap-4" data-id="element-1358">
              <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center text-blue-500" data-id="element-1359">
                <CreditCard size={20} data-id="element-1360" />
              </div>
              <div data-id="element-1361">
                <p className="text-[10px] font-bold text-slate-500 uppercase" data-id="element-1362">
                  Settlement
                </p>
                <p className="text-lg font-bold" data-id="element-1363">T+2 Days</p>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600/10 blur-[100px] -mr-32 -mt-32" data-id="element-1364"></div>
      </div>

      {/* Full Screen Preview Modal */}
      <AnimatePresence data-id="element-1365">
        {previewTemplate && activeTheme && <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4 md:p-8" data-id="element-1366">
            <motion.div initial={{
          opacity: 0,
          y: 50,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} transition={{
          duration: 0.3
        }} className="w-full h-full max-w-7xl bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col relative" data-id="element-1367">
              {/* Modal Controls */}
              <div className="absolute top-4 right-4 z-50 flex gap-3" data-id="element-1368">
                <button onClick={() => {
              setActiveTemplate(previewTemplate);
              setPreviewTemplate(null);
            }} className={`px-4 py-2 ${activeTheme.primary} text-white rounded-lg text-sm font-bold shadow-lg flex items-center gap-2`} data-id="element-1369">
                  <Check size={16} data-id="element-1370" /> Activate This Template
                </button>
                <button onClick={() => setPreviewTemplate(null)} className="w-10 h-10 bg-white text-slate-900 rounded-lg shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-1371">
                  <X size={20} data-id="element-1372" />
                </button>
              </div>

              {/* MOCK STOREFRONT CONTENT */}
              <div className="flex-1 overflow-y-auto bg-gray-50" data-id="element-1373">
                {/* Nav */}
                <nav className="bg-white border-b border-gray-100 px-8 py-4 flex items-center justify-between sticky top-0 z-40" data-id="element-1374">
                  <div className="flex items-center gap-2" data-id="element-1375">
                    <div className={`w-8 h-8 rounded ${activeTheme.primary} flex items-center justify-center text-white font-bold`} data-id="element-1376">
                      M
                    </div>
                    <span className="font-bold text-lg text-slate-900" data-id="element-1377">
                      MyReseller
                    </span>
                  </div>
                  <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-600" data-id="element-1378">
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-1379">
                      Hosting
                    </a>
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-1380">
                      Domains
                    </a>
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-1381">
                      Services
                    </a>
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-1382">
                      Support
                    </a>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-1383">
                    <span className="text-sm font-bold text-slate-900" data-id="element-1384">
                      Login
                    </span>
                    <button className={`px-5 py-2 ${activeTheme.primary} text-white rounded-lg text-sm font-bold`} data-id="element-1385">
                      Get Started
                    </button>
                  </div>
                </nav>

                {/* Hero / Domain Search */}
                <div className={`${activeTheme.light} px-8 py-24 text-center border-b ${activeTheme.border}`} data-id="element-1386">
                  <h1 className="text-4xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-1387">
                    Find Your Perfect Domain
                  </h1>
                  <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-1388">
                    Secure your online identity with our premium hosting and
                    domain registration services. Built for speed, security, and
                    scale.
                  </p>

                  <div className="max-w-3xl mx-auto bg-white p-2 rounded-xl shadow-lg flex items-center" data-id="element-1389">
                    <Search className="text-gray-400 ml-4" size={24} data-id="element-1390" />
                    <input type="text" placeholder="Enter your ideal domain name..." className="flex-1 px-4 py-4 text-lg focus:outline-none" data-id="element-1391" />
                    <button className={`px-8 py-4 ${activeTheme.primary} text-white rounded-lg font-bold text-lg whitespace-nowrap`} data-id="element-1392">
                      Search
                    </button>
                  </div>
                  <div className="mt-6 flex items-center justify-center gap-6 text-sm font-bold text-gray-500" data-id="element-1393">
                    <span data-id="element-1394">.com {sym}15.00</span>
                    <span data-id="element-1395">.ca {sym}12.00</span>
                    <span data-id="element-1396">.net {sym}14.00</span>
                  </div>
                </div>

                {/* Products Showcase */}
                <div className="px-8 py-20 max-w-7xl mx-auto" data-id="element-1397">
                  <div className="text-center mb-16" data-id="element-1398">
                    <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-1399">
                      Powerful Hosting Packages
                    </h2>
                    <p className="text-gray-500" data-id="element-1400">
                      Everything you need to get your business online.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24" data-id="element-1401">
                    {[{
                  name: 'Basic',
                  price: '35',
                  desc: 'Perfect for small sites.'
                }, {
                  name: 'Professional',
                  price: '65',
                  desc: 'For growing businesses.',
                  popular: true
                }, {
                  name: 'Enterprise',
                  price: '99',
                  desc: 'High performance needs.'
                }].map((plan, i) => <div key={i} className={`bg-white rounded-2xl p-8 border ${plan.popular ? `border-2 ${activeTheme.border} shadow-xl relative` : 'border-gray-200 shadow-sm'}`} data-id="element-1402">
                        {plan.popular && <div className={`absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 py-1 ${activeTheme.primary} text-white text-[10px] font-bold uppercase tracking-widest rounded-full`} data-id="element-1403">
                            Most Popular
                          </div>}
                        <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1404">
                          {plan.name}
                        </h3>
                        <p className="text-sm text-gray-500 mb-6" data-id="element-1405">
                          {plan.desc}
                        </p>
                        <div className="mb-8" data-id="element-1406">
                          <span className="text-4xl font-bold text-slate-900" data-id="element-1407">
                            {sym}
                            {plan.price}
                          </span>
                          <span className="text-gray-500" data-id="element-1408">/mo</span>
                        </div>
                        <button className={`w-full py-3 rounded-lg font-bold transition-colors ${plan.popular ? `${activeTheme.primary} text-white` : `${activeTheme.light} ${activeTheme.text} hover:bg-gray-100`}`} data-id="element-1409">
                          Select Plan
                        </button>
                      </div>)}
                  </div>

                  <div className="text-center mb-16" data-id="element-1410">
                    <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-1411">
                      Digital Services & Tools
                    </h2>
                    <p className="text-gray-500" data-id="element-1412">
                      Grow your brand with our expert services and AVA Suite.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1413">
                    <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col items-center text-center" data-id="element-1414">
                      <div className={`w-16 h-16 rounded-2xl ${activeTheme.light} ${activeTheme.text} flex items-center justify-center mb-6`} data-id="element-1415">
                        <Megaphone size={32} data-id="element-1416" />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1417">
                        Digital Marketing
                      </h3>
                      <p className="text-gray-500 text-sm mb-6" data-id="element-1418">
                        SEO, Social Media, and PPC campaigns to drive traffic.
                      </p>
                      <span className={`mt-auto font-bold ${activeTheme.text}`} data-id="element-1419">
                        From {sym}300/mo
                      </span>
                    </div>
                    <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col items-center text-center" data-id="element-1420">
                      <div className={`w-16 h-16 rounded-2xl ${activeTheme.light} ${activeTheme.text} flex items-center justify-center mb-6`} data-id="element-1421">
                        <PenTool size={32} data-id="element-1422" />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1423">
                        Graphic Design
                      </h3>
                      <p className="text-gray-500 text-sm mb-6" data-id="element-1424">
                        Logos, branding, and marketing materials.
                      </p>
                      <span className={`mt-auto font-bold ${activeTheme.text}`} data-id="element-1425">
                        From {sym}250/mo
                      </span>
                    </div>
                    <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col items-center text-center" data-id="element-1426">
                      <div className={`w-16 h-16 rounded-2xl ${activeTheme.light} ${activeTheme.text} flex items-center justify-center mb-6`} data-id="element-1427">
                        <Shield size={32} data-id="element-1428" />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1429">
                        AVA Security Suite
                      </h3>
                      <p className="text-gray-500 text-sm mb-6" data-id="element-1430">
                        Advanced monitoring and DDoS protection for your sites.
                      </p>
                      <span className={`mt-auto font-bold ${activeTheme.text}`} data-id="element-1431">
                        From {sym}15/mo
                      </span>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <footer className="bg-slate-900 text-slate-400 py-12 px-8" data-id="element-1432">
                  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1433">
                    <div data-id="element-1434">
                      <div className="flex items-center gap-2 mb-6" data-id="element-1435">
                        <div className={`w-8 h-8 rounded ${activeTheme.primary} flex items-center justify-center text-white font-bold`} data-id="element-1436">
                          M
                        </div>
                        <span className="font-bold text-lg text-white" data-id="element-1437">
                          MyReseller
                        </span>
                      </div>
                      <p className="text-sm" data-id="element-1438">
                        Empowering businesses online since 2023.
                      </p>
                    </div>
                    <div data-id="element-1439">
                      <h4 className="text-white font-bold mb-4" data-id="element-1440">Services</h4>
                      <ul className="space-y-2 text-sm" data-id="element-1441">
                        <li data-id="element-1442">
                          <a href="#" className="hover:text-white" data-id="element-1443">
                            Web Hosting
                          </a>
                        </li>
                        <li data-id="element-1444">
                          <a href="#" className="hover:text-white" data-id="element-1445">
                            Domains
                          </a>
                        </li>
                        <li data-id="element-1446">
                          <a href="#" className="hover:text-white" data-id="element-1447">
                            Marketing
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-1448">
                      <h4 className="text-white font-bold mb-4" data-id="element-1449">Support</h4>
                      <ul className="space-y-2 text-sm" data-id="element-1450">
                        <li data-id="element-1451">
                          <a href="#" className="hover:text-white" data-id="element-1452">
                            Help Center
                          </a>
                        </li>
                        <li data-id="element-1453">
                          <a href="#" className="hover:text-white" data-id="element-1454">
                            Contact Us
                          </a>
                        </li>
                        <li data-id="element-1455">
                          <a href="#" className="hover:text-white" data-id="element-1456">
                            System Status
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-1457">
                      <h4 className="text-white font-bold mb-4" data-id="element-1458">Legal</h4>
                      <ul className="space-y-2 text-sm" data-id="element-1459">
                        <li data-id="element-1460">
                          <a href="#" className="hover:text-white" data-id="element-1461">
                            Privacy Policy
                          </a>
                        </li>
                        <li data-id="element-1462">
                          <a href="#" className="hover:text-white" data-id="element-1463">
                            Terms of Service
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </footer>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </div>;
}